export class SkillsSocialDetails {
         skillIds: number[]=[];
         facebookUrl: string;
         linkedinUrl: string;
         twitterUrl: string;
         newSkills: string[]=[];
       }
